import { Flex } from 'components/UI/Flex';
import { Button } from 'components/UI/Interactables/Button';
import { Spacer } from 'components/UI/Spacer';
import { Typography } from 'components/UI/Typography';
import { Svgs } from 'environment';
import { usePermissions, useTranslation } from 'hooks/store';

interface Props {
	onCreateClick: () => void;
}

export function NoForms({ onCreateClick }: Props) {
	const { translate } = useTranslation();

	const { hasVariablesWriteAccess } = usePermissions();

	return (
		<Flex align={a => a.center} column>
			<Spacer size={s => s.xxl} />
			<Svgs.EmptyStatesNoForms style={{ minHeight: 240 }} />
			<Spacer size={s => s.m} />
			<Typography.H3>{translate(({ formDesigner }) => formDesigner.noForms)}</Typography.H3>

			{hasVariablesWriteAccess && (
				<>
					<Spacer size={s => s.xs} />
					<Typography.Paragraph>
						{translate(({ formDesigner }) => formDesigner.createFirstForm)}
					</Typography.Paragraph>
					<Spacer size={s => s.m} />
					<Button
						title={translate(({ formDesigner }) => formDesigner.createForm)}
						onClick={onCreateClick}
					/>
				</>
			)}
			<Spacer size={s => s.xxl} />
		</Flex>
	);
}
